import withSession from "grandus-lib/utils/session";
import useWishlist from "grandus-lib/hooks/useWishlist";
import { USER_CONSTANT } from "grandus-lib/constants/SessionConstants";
import { FrownOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";

import Link from "components/_others/link/Link";

import { get, map, upperFirst } from "lodash";
import { Layout, Row, Col, Table, Tag, Result, Button } from "antd";
import MetaData from "grandus-lib/components-atomic/MetaData";

import styles from "./wishlist.page.module.scss";

import AddToCartButton from "components/cart/AddToCartButton";
import Image from "grandus-lib/components-atomic/image/Image";
import Price from "grandus-lib/components-atomic/price/Price";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

const Wishlist = ({ user }) => {
  const { t } = useTranslation();
  const { wishlist, isLoading, itemRemove } = useWishlist();

  if (!user) {
    return (
      <Layout className="container">
        <MetaData
          title={`${upperFirst(t("wishlist:your wislist on"))} www.foon.hu`}
          noindex={true}
        />
        <h1>{upperFirst(t("wishlist:wishlist"))}</h1>
        <Layout.Content>
          <Result
            icon={<LockOutlined />}
            title={upperFirst(t('wishlist:for logged users only'))}
            subTitle={`${upperFirst(t('wishlist:wishlist is available for logged users only'))}. ${upperFirst(t('wishlist:after logging in, your wishlist is automatically shared between all your devices'))}`}
            extra={
              <Link href="/prihlasenie" as="/prihlasenie">
                <Button type="primary">{upperFirst(t("common:login"))}</Button>
              </Link>
            }
          />
        </Layout.Content>
      </Layout>
    );
  }

  const columns = [
    {
      title: upperFirst(t('wishlist:title')),
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: upperFirst(t('wishlist:availability')),
      dataIndex: "avail",
      key: "avail",
      align: "center",
    },
    {
      title: upperFirst(t('wishlist:price')),
      dataIndex: "price",
      key: "price",
      align: "right",
    },
    {
      title: "",
      dataIndex: "primaryAction",
      key: "primaryAction",
      align: "center",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      align: "center",
    },
  ];
  let data = [];

  map(get(wishlist, "items", []), (item, index) => {
    if (get(item, "product.id")) {
      data.push({
        name: (
          <Link
            href="produkt/[id]"
            as={`produkt/${get(item, "product.urlTitle")}`}
          >
            <a>
              <Image
                photo={get(item, "product.photo")}
                size={"50x50"}
                type={"jpg"}
                className={styles?.photo}
              />

              {get(item, "product.name")}
            </a>
          </Link>
        ),
        avail: get(item, "product.storeStatus.available") ? (
          <Tag color="success">
            {get(item, "product.storeStatus.messageAvailable")}
          </Tag>
        ) : (
          <Tag color="error">
            {get(item, "product.storeStatus.messageUnavailable")}
          </Tag>
        ),
        price: <Price priceData={get(item, "product.finalPriceData", {})} />,
        primaryAction: (
          <AddToCartButton
            stores={get(item, "product.store", [])}
            product={get(item, "product")}
          />
        ),
        actions: (
          <Button
            type="text"
            danger
            onClick={(e) =>
              !isLoading && get(item, "product.id")
                ? itemRemove(get(item, "product.id"))
                : null
            }
          >
            <DeleteOutlined /> {upperFirst(t("common:remove"))}
          </Button>
        ),
      });
    }
  });

  if (!data.length) {
    return (
      <Layout className="container guttered">
        <MetaData
          title={`${upperFirst(t("wishlist:your wislist on"))} www.foon.hu`}
        />
        <Layout.Content>
          <Result
            icon={<FrownOutlined />}
            title={upperFirst(t("wishlist:wishlist is empty"))}
            subTitle={`${upperFirst(
              t(
                "wishlist:after inserting some products to the wishlist, it is automatically shared between all your devices"
              )
            )}.`}
          />
        </Layout.Content>
      </Layout>
    );
  }

  return (
    <Layout className="container guttered">
      <MetaData
        title={`${upperFirst(t("wishlist:your wislist on"))} www.foon.hu`}
      />
      <Layout.Content>
        <Row>
          <Col span={24}>
            <Table
              loading={isLoading}
              bordered={true}
              pagination={false}
              columns={columns}
              dataSource={data}
              scroll={{ x: true }}
            />
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  );
};

export const getServerSideProps = withSession(async function ({ req, res, locale }) {
  const user = req.session.get(USER_CONSTANT);

  return {
    props: {
      user: user ? user : null,
      ...(await serverSideTranslations(locale, ["common", "wishlist"])),
    },
  };
});

export default Wishlist;
